import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import "./_canvasOverlay.scss";

/**
 * The tab that opens and closes the left panel, clipped to the panel's right
 * edge. One component for both states — they only differ in which chevron
 * they show and which way they point.
 *
 * Positioning is the caller's job (`style`), with one rule it must respect:
 * centre the tab on the CANVAS area, not on the whole row. Centring on the row
 * puts the tab on top of the timeline dock the moment the timeline is open,
 * and further over it with every pixel the author drags the timeline taller.
 */
const LeftPanelTab = ({ open, onToggle, style }) => {
  const label = open ? i18n.t("ClosePanel") || "Paneli Kapat" : i18n.t("OpenPanel") || "Paneli Aç";
  return (
    <button
      type="button"
      className={`leftPanelTab${open ? " leftPanelTab--open" : ""}`}
      style={style}
      title={label}
      aria-label={label}
      aria-expanded={open}
      onClick={(e) => {
        onToggle();
        // Drop focus so the tab does not keep its focus ring over the canvas.
        e.currentTarget.blur();
      }}
    >
      {open ? <MdChevronLeft /> : <MdChevronRight />}
    </button>
  );
};

LeftPanelTab.propTypes = {
  /** Whether the panel is currently open — picks the chevron direction. */
  open: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  /** Absolute placement, supplied by the caller. */
  style: PropTypes.object,
};

export default LeftPanelTab;
